import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const updateAccount = (
      firstName
    , lastName
    , accountType
    , accountPrivacy
    , category
    , professionalType
    , gender
    , birthDate
    , description
    , userId
    , countryName
    , countryCd
    , countryCurrCd
    , countryTelCd
    , hideMobileNumber
    , location
    , userLat
    , userLng
    ) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        // Prepare plain object instead of FormData
        const data = {
            firstName,
            lastName,
            accountType,
            accountPrivacy,
            category,
            professionalType,
            gender,
            birthDate,
            description,
            userId,
            countryName,
            countryCd,
            countryCurrCd,
            countryTelCd,
            hideMobileNumber,
            userLocation: location,  // rename location to userLocation to match backend param
            userLat,
            userLng
        };

        axios({
          method : "POST",
          url :  api_url + "/UpdateAccount",
          data : JSON.stringify(data),
          headers:  { 
            "Content-Type": "application/json", 
            'Authorization': 'Bearer ' + jwtToken 
          },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const getUserAccountInfo = () =>{
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');
        var fdAccount = new FormData();
         
        axios({
          method : "POST",
          url :  api_url + "/DownloadAccountInfo",
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken, },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const getUserByMobileNumber = (mobileNumber) =>{
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');
         
        axios({
          method : "GET",
          url :  api_url + "/GetUserByMobileNumber",
          params: {"mobileNumber": mobileNumber},
          headers:  { "Content-Type": "application/json", 'Authorization': 'Bearer ' + jwtToken, },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const getCurrentPassword = () =>{
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');         
        axios({
          method : "POST",
          url :  api_url + "/GetCurrentPassword",
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const updatePassword = (password) =>{
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');
        var fdAccount = new FormData();
        fdAccount.append('password', password);
         
        axios({
          method : "POST",
          url :  api_url + "/UpdatePassword",
          data : fdAccount,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const getProfessionalPreferenceSettings = (userId) =>{
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');
        var fdAccount = new FormData();
     	fdAccount.append('userId', userId);

        axios({
          method : "POST",
          url :  api_url + "/GetProfessionalPreferenceSettings",
          data : fdAccount,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

// Only the AI assistant: email and app alerts are set on Account > Notifications
// (api/user/notification-preferences-api.js), and the backend leaves them alone when absent.
export const updateProfessionalPreferenceSettings = (aiAssistant) =>{
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');
        var fdAccount = new FormData();
        fdAccount.append('aiAssistant', aiAssistant);
                  
        axios({
          method : "POST",
          url :  api_url + "/UpdateProfessionalPreferenceSettings",
          data : fdAccount,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const updateAccountPrivacy = (userPrivacySetting) =>{
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');
        var fdAccount = new FormData();
        fdAccount.append('userPrivacySetting', userPrivacySetting);

        axios({
          method : "POST",
          url :  api_url + "/UpdateAccountPrivacy",
          data : fdAccount,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const updateActiveInd = (emailId) =>{
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');
        var fdAccount = new FormData();
        fdAccount.append('emailId', emailId);

        axios({
          method : "POST",
          url :  api_url + "/UpdateActiveInd",
          data : fdAccount,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const updateMobileVerificationInd = (userId, isMobileVerified) =>{
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');
        var fdAccount = new FormData();
        fdAccount.append('userId', userId);
        fdAccount.append('isMobileVerified', isMobileVerified);

        axios({
          method : "POST",
          url :  api_url + "/UpdateMobileVerificationInd",
          data : fdAccount,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const deactivateAccount = () =>{
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');
        var fdAccount = new FormData();

        axios({
          method : "POST",
          url :  api_url + "/DeactivateAccount",
          data : fdAccount,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const deleteAccount = () =>{
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        axios({
          method : "POST",
          url :  api_url + "/DeleteAccount",
          headers:  { "Content-Type": "application/json", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const updatePayoutPageAccess = () =>{
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        axios({
          method : "POST",
          url :  api_url + "/UpdatePayoutPageAccess",
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const updateUserByAdmin = (
        userId
    ,   loginUserId
    ,   firstName
    ,   lastName
    ,   userLocation
    ) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        // Prepare plain object instead of FormData
        const data = {
            userId,            
            loginUserId,
            firstName,
            lastName,
            userLocation
        };

        axios({
          method : "POST",
          url :  api_url + "/UpdateUserByAdmin",
          data : JSON.stringify(data),
          headers:  { 
            "Content-Type": "application/json", 
            'Authorization': 'Bearer ' + jwtToken 
          },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}